
function makeWorkBox(item) {
    return;
    console.log("INIT BOX");
    var prefixit=item.attr("data-prefix");
    var field=item.attr("data-field");

    var $field=$("input[name='"+field+"']");
    var $fieldValue=$field.val();
    try {
        $fieldValue=JSON.parse($fieldValue);
    }catch (E) {
        $fieldValue=null;
    }

    var updateField=function() {
        console.log("on update");
        if(!$fieldValue) {
            $fieldValue={};
        }

        $fieldValue._m_t1=$("input[name="+prefixit+"_m_t1]").val();
        $fieldValue._m_t2=$("input[name="+prefixit+"_m_t2]").val();
        $fieldValue._m_t3=$("input[name="+prefixit+"_m_t3]").val();
        $fieldValue._m_t4=$("input[name="+prefixit+"_m_t4]").val();

        $fieldValue._tu_t1=$("input[name="+prefixit+"_tu_t1]").val();
        $fieldValue._tu_t2=$("input[name="+prefixit+"_tu_t2]").val();
        $fieldValue._tu_t3=$("input[name="+prefixit+"_tu_t3]").val();
        $fieldValue._tu_t4=$("input[name="+prefixit+"_tu_t4]").val();

        $fieldValue._we_t1=$("input[name="+prefixit+"_we_t1]").val();
        $fieldValue._we_t2=$("input[name="+prefixit+"_we_t2]").val();
        $fieldValue._we_t3=$("input[name="+prefixit+"_we_t3]").val();
        $fieldValue._we_t4=$("input[name="+prefixit+"_we_t4]").val();

        $fieldValue._th_t1=$("input[name="+prefixit+"_th_t1]").val();
        $fieldValue._th_t2=$("input[name="+prefixit+"_th_t2]").val();
        $fieldValue._th_t3=$("input[name="+prefixit+"_th_t3]").val();
        $fieldValue._th_t4=$("input[name="+prefixit+"_th_t4]").val();

        $fieldValue._fr_t1=$("input[name="+prefixit+"_fr_t1]").val();
        $fieldValue._fr_t2=$("input[name="+prefixit+"_fr_t2]").val();
        $fieldValue._fr_t3=$("input[name="+prefixit+"_fr_t3]").val();
        $fieldValue._fr_t4=$("input[name="+prefixit+"_fr_t4]").val();

        $fieldValue._sa_t1=$("input[name="+prefixit+"_sa_t1]").val();
        $fieldValue._sa_t2=$("input[name="+prefixit+"_sa_t2]").val();
        $fieldValue._sa_t3=$("input[name="+prefixit+"_sa_t3]").val();
        $fieldValue._sa_t4=$("input[name="+prefixit+"_sa_t4]").val();

        $fieldValue._su_t1=$("input[name="+prefixit+"_su_t1]").val();
        $fieldValue._su_t2=$("input[name="+prefixit+"_su_t2]").val();
        $fieldValue._su_t3=$("input[name="+prefixit+"_su_t3]").val();
        $fieldValue._su_t4=$("input[name="+prefixit+"_su_t4]").val();

        $field.val(JSON.stringify($fieldValue));
        console.log($fieldValue);
    };


    if($fieldValue) {

        $("input[name="+prefixit+"_m_t1]").val($fieldValue._m_t1);
        $("input[name="+prefixit+"_m_t2]").val($fieldValue._m_t2);
        $("input[name="+prefixit+"_m_t3]").val($fieldValue._m_t3);
        $("input[name="+prefixit+"_m_t4]").val($fieldValue._m_t4);

        $("input[name="+prefixit+"_tu_t1]").val($fieldValue._tu_t1);
        $("input[name="+prefixit+"_tu_t2]").val($fieldValue._tu_t2);
        $("input[name="+prefixit+"_tu_t3]").val($fieldValue._tu_t3);
        $("input[name="+prefixit+"_tu_t4]").val($fieldValue._tu_t4);

        $("input[name="+prefixit+"_we_t1]").val($fieldValue._we_t1);
        $("input[name="+prefixit+"_we_t2]").val($fieldValue._we_t2);
        $("input[name="+prefixit+"_we_t3]").val($fieldValue._we_t3);
        $("input[name="+prefixit+"_we_t4]").val($fieldValue._we_t4);

        $("input[name="+prefixit+"_th_t1]").val($fieldValue._th_t1);
        $("input[name="+prefixit+"_th_t2]").val($fieldValue._th_t2);
        $("input[name="+prefixit+"_th_t3]").val($fieldValue._th_t3);
        $("input[name="+prefixit+"_th_t4]").val($fieldValue._th_t4);

        $("input[name="+prefixit+"_fr_t1]").val($fieldValue._fr_t1);
        $("input[name="+prefixit+"_fr_t2]").val($fieldValue._fr_t2);
        $("input[name="+prefixit+"_fr_t3]").val($fieldValue._fr_t3);
        $("input[name="+prefixit+"_fr_t4]").val($fieldValue._fr_t4);

        $("input[name="+prefixit+"_sa_t1]").val($fieldValue._sa_t1);
        $("input[name="+prefixit+"_sa_t2]").val($fieldValue._sa_t2);
        $("input[name="+prefixit+"_sa_t3]").val($fieldValue._sa_t3);
        $("input[name="+prefixit+"_sa_t4]").val($fieldValue._sa_t4);

        $("input[name="+prefixit+"_su_t1]").val($fieldValue._su_t1);
        $("input[name="+prefixit+"_su_t2]").val($fieldValue._su_t2);
        $("input[name="+prefixit+"_su_t3]").val($fieldValue._su_t3);
        $("input[name="+prefixit+"_su_t4]").val($fieldValue._su_t4);
    }

    //check all
    $(item).find(".fg-line").each(function(i,item){
        var input = $(item).find("input");
        var parent= $(item);
        if(!input.val().length) {
            parent.find("button").hide();
        }
        input.on("change blur",function(){
            if(input.val().length) {
                parent.find("button").show();
            }else{
                parent.find("button").hide();
            }
        });
        parent.find("button").on("click",function(){
            input.val("");
            parent.find("button").hide();
            updateField();
            return false;
        });
    });



    $("input[name="+prefixit+"_m_t1]").on("change focus blur",updateField);
    $("input[name="+prefixit+"_m_t2]").on("change focus blur",updateField);
    $("input[name="+prefixit+"_m_t3]").on("change focus blur",updateField);
    $("input[name="+prefixit+"_m_t4]").on("change focus blur",updateField);

    $("input[name="+prefixit+"_tu_t1]").on("change focus blur",updateField);
    $("input[name="+prefixit+"_tu_t2]").on("change focus blur",updateField);
    $("input[name="+prefixit+"_tu_t3]").on("change focus blur",updateField);
    $("input[name="+prefixit+"_tu_t4]").on("change focus blur",updateField);

    $("input[name="+prefixit+"_we_t1]").on("change focus blur",updateField);
    $("input[name="+prefixit+"_we_t2]").on("change focus blur",updateField);
    $("input[name="+prefixit+"_we_t3]").on("change focus blur",updateField);
    $("input[name="+prefixit+"_we_t4]").on("change focus blur",updateField);

    $("input[name="+prefixit+"_th_t1]").on("change focus blur",updateField);
    $("input[name="+prefixit+"_th_t2]").on("change focus blur",updateField);
    $("input[name="+prefixit+"_th_t3]").on("change focus blur",updateField);
    $("input[name="+prefixit+"_th_t4]").on("change focus blur",updateField);

    $("input[name="+prefixit+"_fr_t1]").on("change focus blur",updateField);
    $("input[name="+prefixit+"_fr_t2]").on("change focus blur",updateField);
    $("input[name="+prefixit+"_fr_t3]").on("change focus blur",updateField);
    $("input[name="+prefixit+"_fr_t4]").on("change focus blur",updateField);

    $("input[name="+prefixit+"_sa_t1]").on("change focus blur",updateField);
    $("input[name="+prefixit+"_sa_t2]").on("change focus blur",updateField);
    $("input[name="+prefixit+"_sa_t3]").on("change focus blur",updateField);
    $("input[name="+prefixit+"_sa_t4]").on("change focus blur",updateField);

    $("input[name="+prefixit+"_su_t1]").on("change focus blur",updateField);
    $("input[name="+prefixit+"_su_t2]").on("change focus blur",updateField);
    $("input[name="+prefixit+"_su_t3]").on("change focus blur",updateField);
    $("input[name="+prefixit+"_su_t4]").on("change focus blur",updateField);
}


function workTimeCheck() {
    $(".worktime-box").each(function(){
        if(!this.alsoinited) {
            this.alsoinited=true;
            makeWorkBox($(this));
        }else{
            console.log("repeatinit");
        }
    });
}

$(function(){
    workTimeCheck();
});